import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { getYear } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { styled, IconButton } from "@mui/material";
import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded
} from "@mui/icons-material";

const koWeekDay = {
  Sunday: "일",
  Monday: "월",
  Tuesday: "화",
  Wednesday: "수",
  Thursday: "목",
  Friday: "금",
  Saturday: "토"
} as { [key in string]: string };

const YEARS = Array.from(
  { length: getYear(new Date()) + 1 - 2000 },
  (_, i) => getYear(new Date()) - i
);

const Custom = styled(DatePicker)`
  width: 100%;
  height: 36px;
  border-radius: 7px;
  border: 1px solid #e5eaef;
  .react-datepicker {
    .react-datepicker__header {
      background-color: blue;
    }
  }
`;

const CustomMonthPicker = ({
  selected,
  onChange
}: {
  selected: ReactDatePickerProps["selected"];
  onChange: ReactDatePickerProps["onChange"];
}) => {
  return (
    <Custom
      showIcon
      dateFormat="yyyy.MM"
      formatWeekDay={nameOfDay => koWeekDay[nameOfDay]}
      selected={selected}
      onChange={onChange}
      showMonthYearPicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#FFF",
            height: "100%",
            marginTop: "8px"
          }}
        >
          <IconButton
            onClick={decreaseMonth}
            style={{
              width: "34px",
              height: "34px",
              padding: "5px",
              borderRadius: "50%"
            }}
            disabled={prevMonthButtonDisabled}
          >
            <KeyboardArrowLeftRounded />
          </IconButton>

          <select
            value={getYear(date)}
            style={{
              fontSize: "16px",
              fontWeight: 500,
              paddingRight: "5px",
              cursor: "pointer"
            }}
            onChange={({ target: { value } }) => changeYear(+value)}
          >
            {YEARS.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <IconButton
            onClick={increaseMonth}
            style={{
              width: "34px",
              height: "34px",
              padding: "5px",
              borderRadius: "50%"
            }}
            disabled={nextMonthButtonDisabled}
          >
            <KeyboardArrowRightRounded />
          </IconButton>
        </div>
      )}
    />
  );
};

export default CustomMonthPicker;
